import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { BookOpen } from "lucide-react";

import { EmptyState } from "@/components/ui/empty-state";
import { Skeleton } from "@/components/ui/skeleton";
import { WikiLabels } from "@/lib/labels/wiki";

import { WikiCreate } from "./-components/wiki-create";
import { WikiLayout } from "./-components/wiki-layout";

export const Route = createFileRoute("/_app/wiki/")({
	component: WikiIndexPage,
});

function WikiIndexPage() {
	const [creating, setCreating] = useState(false);

	return (
		<WikiLayout
			activeSlug={null}
			onCreate={() => setCreating(true)}
			onCloseCreate={() => setCreating(false)}
		>
			{({ pages, isLoading }) => (
				<>
					{isLoading && (
						<div className="surface-panel p-6 lg:p-8">
							<Skeleton className="h-9 w-2/3" />
							<Skeleton className="mt-6 h-4 w-full" />
							<Skeleton className="mt-2.5 h-4 w-3/4" />
						</div>
					)}

					{!isLoading && (
						<div className="surface-panel">
							<EmptyState
								icon={BookOpen}
								title={pages.length === 0 ? WikiLabels.emptyTitle : WikiLabels.pickPage}
							/>
						</div>
					)}

					{creating && <WikiCreate onClose={() => setCreating(false)} />}
				</>
			)}
		</WikiLayout>
	);
}
